module.exports = __webpack_public_path__ + "static/img/kota2.5061959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/kota2.png
// module id = RxrK
// module chunks = 0